import React from 'react';
import './Features.css';

const Features = () => {
  const services = [
    {
      title: 'Research',
      description: 'We study prediction markets using quantitative analysis, statistical modeling, and empirical methods to understand how probabilities form and evolve.'
    },
    {
      title: 'Technology',
      description: 'We build the data systems, modeling pipelines, and analytical tools that support rapid-feedback experimentation and large-scale research.'
    },
    {
      title: 'Trading',
      description: 'We employ both systematic execution and discretionary reasoning to trade effectively across dynamic prediction-market environments, using quantitative models, real-time signals, and informed human judgment.'
    }
  ];

  return (
    <section className="features" id="services">
      <div className="features-container">
        <h2 className="section-title">What We Do</h2>
        <p className="section-subtitle">Systematic Investing Grounded in Probabilistic Reasoning</p>
        <div className="services-grid">
          {services.map((service, index) => (
            <div className="service-card" key={index}>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
